import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
// import LightBox from '@bd/bdui-lightbox';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import LivingMenu from '../../components/menus/FYH';
import ContentBanner from '../../components/ContentBanner';
import AreaContent from './AreaContent';
import { typography } from '../../styles/';
import OutDoorRec from './OutDoorRec';
import Schools from './Schools';
import UpcomingEvents from './UpcomingEvents';
import MapModal from './MapModal';

const styles = css`
  background-color: #000000;
  .MasterPlan {
    display: block;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
  .Btn_enlargeWrapper{
    max-width: 1200px;
    margin: 0 auto;
  }
  .Btn_enlarge{
    max-width: 200px;
    color: white;
    font-family: ${typography.SansSerif};
    padding-left: 50px;
    position: relative;
    cursor: pointer;
    margin: 20px 0 20px auto;
    font-size: 14px;
    font-weight: bold;
    &:after{
      content: '';
      background-image: url('images/i-magnify-white.svg');
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 25px;
      top: 18px;
      height: 25px;
      width: 25px;
    }
  }
`;

const lightboxStyles = css`
  height: 100%;
  width: auto;
  .image-current{
    height:100% !important;
    width:auto !important;
  }
`;

function Overview({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        carouselSlides={get(page, 'page_image', [])}
        video={get(page, 'header_video.contentUrl')}
      />
      <LivingMenu />
      <ContentBanner
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      />
      <section className="container mb-4">
        {/* <LightBox className={lightboxStyles} items={[get(page, 'master_plan')]}>
          <img
            src={get(page, 'master_plan.contentUrl')}
            alt={get(page, 'master_plan.name', '')}
            className="MasterPlan"
          />
          <div className="Btn_enlargeWrapper">
            <div className="Btn Gold Btn_enlarge">Enlarge Map</div>
          </div>
        </LightBox> */}
        <MapModal className={lightboxStyles} map={get(page, 'master_plan.contentUrl')}>
          <img
            src={get(page, 'master_plan.contentUrl')}
            alt={get(page, 'master_plan.name', '')}
            className="MasterPlan"
          />
          <div className="Btn_enlargeWrapper">
            <div className="Btn Gold Btn_enlarge">Enlarge Map</div>
          </div>
        </MapModal>
      </section>
      <OutDoorRec content={get(page, 'outdoor_recreation')} />
      <AreaContent page={page} />
      <Schools page={page} />
      <UpcomingEvents content={get(page, 'upcoming_events')} />
      {get(page, 'calendars') && get(page, 'calendars').length > 0 &&
        <div className="Calendar_btnWrapper container d-flex flex-column flex-lg-row justify-content-center pb-5">
          {
            get(page, 'calendars').map(btn => (
              <a className="Btn Hollow" key={btn._id} href={btn.file.contentUrl} target="_blank" rel="noopener noreferrer">{btn.button_text || 'Download'}</a>
            ))
          }
        </div>
      }
    </PageWrapper>
  );
}

Overview.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'overview',
})(Overview);



// WEBPACK FOOTER //
// ./src/pages/Overview/index.js